/* Hinweisblock: Countdown und automatisches Ausblenden nach Ablauf.
 *
 * Warum ueberhaupt JS: Liquid rendert mit Serverzeit und die Seite wird von
 * Shopify zwischengespeichert. Ohne Client-Pruefung koennte ein abgelaufener
 * Hinweis noch stehen. Die Liquid-Seite blendet grob aus, dieses Skript
 * korrigiert sekundengenau.
 */
(function () {
  if (customElements.get('urgency-note')) return;

  var MINUTE = 60, HOUR = 3600, DAY = 86400;

  function plural(n, one, many) {
    return n + ' ' + (n === 1 ? one : many);
  }

  class UrgencyNote extends HTMLElement {
    connectedCallback() {
      var until = this.dataset.until;
      if (!until) return;

      this.deadline = Date.parse(until);
      if (isNaN(this.deadline)) return; // unlesbares Datum: Hinweis stehen lassen

      this.output = this.querySelector('[data-un-countdown-value]');
      this.tick();
      this.timer = setInterval(this.tick, 1000);
    }

    disconnectedCallback() {
      if (this.timer) clearInterval(this.timer);
    }

    tick = () => {
      var left = Math.floor((this.deadline - Date.now()) / 1000);

      if (left <= 0) {
        this.hidden = true;
        if (this.timer) clearInterval(this.timer);
        return;
      }

      if (!this.output) return;

      var parts = [];
      if (left >= DAY) {
        parts.push(plural(Math.floor(left / DAY), 'Tag', 'Tage'));
        parts.push(plural(Math.floor((left % DAY) / HOUR), 'Stunde', 'Stunden'));
      } else if (left >= HOUR) {
        parts.push(plural(Math.floor(left / HOUR), 'Stunde', 'Stunden'));
        parts.push(plural(Math.floor((left % HOUR) / MINUTE), 'Minute', 'Minuten'));
      } else {
        parts.push(plural(Math.floor(left / MINUTE), 'Minute', 'Minuten'));
        parts.push(plural(left % MINUTE, 'Sekunde', 'Sekunden'));
      }

      this.output.textContent = parts.join(' ');
    };
  }

  customElements.define('urgency-note', UrgencyNote);
})();
